<template>
    <section>
        <v-container v-if="userCan('receipts_reports')">
            <v-row dense>
                <v-col class="col-md-3 col-xs-12">
                    <ReceiptReportCard color='success' title="پرداختی های امروز" :filters="{ 'created_at' : { 'column_name' : 'created_at', 'operand' : 'Between', value : dateRanges.today }}"></ReceiptReportCard>
                </v-col>
                <v-col class="col-md-3 col-xs-12">
                    <ReceiptReportCard color="info" title="پرداختی های دیروز" :filters="{ 'created_at' : { 'column_name' : 'created_at', 'operand' : 'Between', value : dateRanges.yesterday }}"></ReceiptReportCard>
                </v-col>
                <v-col class="col-md-3 col-xs-12">
                    <ReceiptReportCard color="warning" title="پرداختی هفته جاری" :filters="{ 'created_at' : { 'column_name' : 'created_at', 'operand' : 'Between', value : dateRanges.current_week }}"></ReceiptReportCard>
                </v-col>
                <v-col class="col-md-3 col-xs-12">
                    <ReceiptReportCard color="scondary" title="پرداختی ماه جاری" :filters="{ 'created_at' : { 'column_name' : 'created_at', 'operand' : 'Between', value : dateRanges.current_month }}"></ReceiptReportCard>
                </v-col>
            </v-row>
        </v-container>

        <v-container>
            <v-row dense>
                <v-col class="col-md-12"  v-if="userCan('users_reports')">
                    <UserRegisterReport color='success' title="گزارش ثبت نام کاربران"></UserRegisterReport>
                </v-col>
            </v-row>
        </v-container>
        <v-container>
            <v-row dense>
                <v-col class="col-md-12"  v-if="userCan('faxes_reports')">
                    <SubscriptionsReportBar title="گزارش اشتراک ها"></SubscriptionsReportBar>
                </v-col>
            </v-row>
        </v-container>
        
        <v-container  v-if="userCan('faxes_reports')">
            <v-row dense>
                <v-col class="col-md-8">
                    <FaxReportBar color='success' title="فکس انبوه" :statuses="['waiting_to_send','sending','blacklist','failed','completed']" :filters="{ 'fax_broadcast_id' : { 'column_name' : 'fax_broadcast_id', 'operand' : 'IsNotNull', value : null }, 'type' : { 'column_name' : 'type', 'operand' : 'IsEqualTo', value : 'outgoing' }}"></FaxReportBar>
                </v-col>
                <v-col class="col-md-4"  v-if="userCan('faxes_reports')">
                    <FaxOverviewReport type='outgoing' title="فکس انبوه" :extraFilters="{ 'fax_broadcast_id' : { 'column_name' : 'fax_broadcast_id', 'operand' : 'IsNotNull', value : null }}"></FaxOverviewReport>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col class="col-md-8">
                    <FaxReportBar color='success' title="ریز گزارش فکس های ارسالی" :statuses="['waiting_to_send','sending','blacklist','failed','completed']" :filters="{ 'fax_broadcast_id' : { 'column_name' : 'fax_broadcast_id', 'operand' : 'IsNull', value : null }, 'type' : { 'column_name' : 'type', 'operand' : 'IsEqualTo', value : 'outgoing' }}"></FaxReportBar>
                </v-col>
                <v-col class="col-md-4"  v-if="userCan('faxes_reports')">
                    <FaxOverviewReport type='outgoing' title="گزارش کلی فکس های ارسالی" :extraFilters="{ 'fax_broadcast_id' : { 'column_name' : 'fax_broadcast_id', 'operand' : 'IsNull', value : null }}"></FaxOverviewReport>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col class="col-md-8">
                    <FaxReportBar color='success' title="ریز گزارش  دریافت ها" :statuses="['incoming_queue','receiving','failed_receive','received']"  :filters="{ 'type' : { 'column_name' : 'type', 'operand' : 'IsEqualTo', value : 'incoming' }}"></FaxReportBar>
                </v-col>
                <v-col class="col-md-4"  v-if="userCan('faxes_reports')">
                    <FaxOverviewReport  type='incoming' title="گزارش کلی دریافت ها"></FaxOverviewReport>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
    import ReceiptReportCard from '../components/ReceiptReportCard';
    import UserRegisterReport from '../components/UserRegisterReport';
    import FaxReportBar from '../components/FaxReportBar';
    import FaxOverviewReport from '../components/FaxOverviewReport';
    import SubscriptionsReportBar from '../components/SubscriptionsReportBar';
    import Moment from 'moment-jalaali';

    export default {
        components : {
            ReceiptReportCard,
            UserRegisterReport,
            FaxReportBar,
            FaxOverviewReport,
            SubscriptionsReportBar
        },
        data(){
            return {
                todayTimestamp : 1602621000,
                tomorrowTimestamp : 1602621000,
                dialog : false,
                dateRanges: {
                    today: [Moment().startOf('day').unix(), Moment().endOf('day').unix()],
                    yesterday: [Moment().add(-1, 'day').startOf('day').unix(), Moment().add(-1, 'day').endOf('day').unix()],
                    current_week: [Moment().startOf('week').unix(), Moment().endOf('day').unix()],
                    current_month: [Moment().startOf('jMonth').unix(), Moment().endOf('day').unix()]
                },
            }
        },

    }
</script>